import React from "react";
import { useTranslation } from "react-i18next";

import { FilterMenu } from "@common/filterMenu";
import { Props } from "./types";
import styles from "./styles.scss";

function Filters({ filter, setFilter }: Props) {
  const { t } = useTranslation();

  return (
    <div className={styles.filters}>
      <div className={styles.section}>
        <p className={styles.label}>
          {t("exportReportsPage.taskBudgetReport.filters.title")}
        </p>
        <FilterMenu
          filter={filter}
          placeholder={t(
            "exportReportsPage.taskBudgetReport.filters.projectDefault",
          )}
          views={["zones", "projects"]}
          openedViews={["projects"]}
          setFilter={setFilter}
        />
      </div>
      <div>
        <button
          className={styles.resetButton}
          onClick={() =>
            setFilter({
              projects: [],
            })
          }
        >
          {t("exportReportsPage.taskBudgetReport.filters.resetFilters")}
        </button>
      </div>
    </div>
  );
}

export { Filters };
